/* 🤖 this file was generated by svg-to-ts */
export const siriusThumbsDown: {
  name: 'thumbs_down';
  data: string;
} = {
  name: 'thumbs_down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 3.75a1.5 1.5 0 0 0-1.5 1.5v8.25A1.5 1.5 0 0 0 3 15h4.036l3.543 7.085a.75.75 0 0 0 .67.415A3.75 3.75 0 0 0 15 18.75v-1.5h5.051a2.25 2.25 0 0 0 2.233-2.53l-1.125-9a2.25 2.25 0 0 0-2.233-1.97H3Zm5.25 1.5v8.823l3.441 6.883a2.246 2.246 0 0 0 1.637-1.345 2.25 2.25 0 0 0 .171-.861V16.5a.75.75 0 0 1 .75-.75h5.801a.75.75 0 0 0 .744-.843l-1.125-9a.75.75 0 0 0-.744-.657H8.25ZM3 13.5V5.25h3.75v8.25H3Z" fill="currentColor"/></svg>`
};
